import React, { useMemo } from 'react';
import SearchIcon from '@atlaskit/icon/glyph/search';
import { COMMAND_PALETTE_SECTIONS } from '@atlassian/jira-command-palette-common/src/common/constants.tsx';
import { QuickSearchChildWrapper } from '@atlassian/jira-command-palette-quick-search/src/ui/use-quick-search-command/use-quick-search-children/wrapper/index.tsx';
import {
	type Command,
	CommandActionType,
} from '@atlassian/jira-command-palette/src/common/types/commands/index.tsx';
import { useIntl } from '@atlassian/jira-intl';
import { QUICK_SEARCH_ID } from './constants';
import { messages } from './messages';
import { useFireQuickSearchAnalyticsOnClose } from './use-fire-quick-search-analytics-on-close';
import { QuickSearchChildren } from './use-quick-search-children';

export const useQuickSearchCommand = (props?: { keepSearch?: boolean }) => {
	const keepSearch = props?.keepSearch;
	const { formatMessage } = useIntl();

	useFireQuickSearchAnalyticsOnClose();
	const quickSearchCommand = useMemo(
		(): Command => ({
			id: QUICK_SEARCH_ID,
			name: formatMessage(messages.searchCommandName),
			placeholder: formatMessage(messages.searchInputPlaceHolder),
			keywords: formatMessage(messages.searchYourIssuesSynonyms),
			components: {
				LeftIcon: () => <SearchIcon label="" />,
			},
			mode: '/',
			section: COMMAND_PALETTE_SECTIONS.quickSearch,
			priority: 1,
			analytics: {
				action: 'quickSearchMode',
				actionCategory: 'quick-search',
			},
			primaryAction: {
				type: CommandActionType.COMMAND_LIST,
				components: {
					Body: QuickSearchChildren,
					Wrapper: QuickSearchChildWrapper,
				},
				keepSearch,
			},
		}),
		[formatMessage, keepSearch],
	);

	return { quickSearchCommand };
};
